import queryString from 'query-string';

import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import {
  referralsStateForJobIdSelector,
  referralsStateForOrgIdSelector,
} from '../referrals-selectors';

import * as Api from '../../api/api';

export const loadReferralsByOrgId = (orgId: number, includeUnlinked?: boolean) =>
  createGenericDispatcher<Array<Referral>>({
    name: 'LOAD_REFERRALS_BY_ORG_ID',
    loadFunction: () =>
      Api.get(`/referral?${queryString.stringify({ orgId, includeUnlinked }, { skipNull: true })}`),
    args: { orgId, includeUnlinked },
    shouldExecuteSelector: (state: any) => referralsStateForOrgIdSelector(state, orgId),
  });

export const loadReferralsByJobId = (jobId: number, includeUnlinked?: boolean) =>
  createGenericDispatcher<Array<Referral>>({
    name: 'LOAD_REFERRALS_BY_JOB_ID',
    loadFunction: () =>
      Api.get(`/referral?${queryString.stringify({ jobId, includeUnlinked }, { skipNull: true })}`),
    args: { jobId, includeUnlinked },
    shouldExecuteSelector: (state: any) => referralsStateForJobIdSelector(state, jobId),
  });
